import classNames from 'classnames'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import styles from './PendingPayment.module.scss'
import { ClockSvg } from './assets/ClockSvg'

type PendingPaymentProps = {
  className?: string
  text?: string
}

export const PendingPayment: FC<PendingPaymentProps> = ({
  className,
  text,
}) => {
  const { t } = useTranslation()

  return (
    <div className={classNames(styles.container, className)}>
      <ClockSvg className={styles.icon} />
      <p className={styles.text}>{text || t('pendingPayment.text')}</p>
    </div>
  )
}
